function q<T extends HTMLElement>(selector: string): T | null {
  return document.querySelector<T>(selector);
}

function qAll<T extends HTMLElement>(selector: string): NodeListOf<T> {
  return document.querySelectorAll<T>(selector);
}

function id<T extends HTMLElement>(elementId: string): T | null {
  return document.getElementById(elementId) as T | null;
}

export const els = {
  navItems: qAll('.nav-item'),
  panels: qAll('.panel'),
  dashboardNav: q('.nav-item[data-tab="dashboard"]'),
  entryNav: q('.nav-item[data-tab="entry"]'),
  matrixNav: q('.nav-item[data-tab="matrix"]'),
  bookingNav: q('.nav-item[data-tab="booking"]'),
  bookingMatrixNav: q('.nav-item[data-tab="booking-matrix"]'),
  adminNav: q('.nav-item[data-tab="admin"]'),
  pageTitle: id('page-title'),
  roleSelect: id<HTMLSelectElement>('role-select'),
  roleBadge: id('role-badge'),
  currentRole: id('current-role'),
  providerName: id('provider-name'),
  lastSync: id('last-sync'),
  refreshBtn: id('refresh-btn'),
  logoutBtn: id('logout-btn'),

  filterDivision: id<HTMLSelectElement>('filter-division'),
  filterBrand: id<HTMLSelectElement>('filter-brand'),
  filterCountry: id<HTMLSelectElement>('filter-country'),
  filterType: id<HTMLSelectElement>('filter-type'),
  filterOwner: id<HTMLSelectElement>('filter-owner'),
  clearFiltersBtn: id('clear-filters-btn'),
  dashboardChart: id('dashboard-chart'),
  chartDimTabs: qAll('.chart-dim-tab'),
  chartHistModeTabs: qAll('.chart-hist-mode-tab'),
  histTooltip: id('hist-tooltip'),
  tableBody: id('forecast-table-body'),
  kpiTotal: id('kpi-total'),
  kpiQty: id('kpi-qty'),
  kpiAssets: id('kpi-assets'),
  kpiCountries: id('kpi-countries'),
  kpiProjects: id('kpi-projects'),
  kpiAssetCount: id('kpi-asset-count'),
  divisionBreakdown: id('division-breakdown'),
  quarterBreakdown: id('quarter-breakdown'),
  monthBreakdown: id('month-breakdown'),

  entryLock: id('entry-lock'),
  entryMaster: id('entry-tinder'),
  entryLocal: id('entry-market'),
  viewToggleBtns: qAll('.toggle-btn'),
  dateModal: id('date-modal'),
  launchDateInput: id<HTMLInputElement>('launch-date-input'),
  launchCountrySelect: id<HTMLSelectElement>('launch-country-select'),
  modalProductName: id('modal-product-name'),
  modalAssetVolume: id('modal-asset-volume'),
  modalConfirmBtn: id('modal-confirm-btn'),
  modalCancelBtn: id('modal-cancel-btn'),
  formMessage: id('form-message'),

  marketTableBody: id('market-table-body'),
  marketFilter: id<HTMLSelectElement>('market-filter'),
  marketStatusFilter: id<HTMLSelectElement>('market-status-filter'),
  marketHubFilter: id<HTMLSelectElement>('market-hub-filter'),
  marketBrandEntryFilter: id<HTMLSelectElement>('market-brand-filter'),
  marketDivisionFilter: id<HTMLSelectElement>('market-division-filter'),
  marketBulkDate: id<HTMLInputElement>('market-bulk-date'),
  marketValidateSelectedBtn: id('market-validate-selected-btn'),
  marketSelectAll: id<HTMLInputElement>('market-select-all'),
  marketMessage: id('market-message'),

  localDivision: id<HTMLSelectElement>('local-division'),
  localBrand: id<HTMLSelectElement>('local-brand'),
  localHub: id<HTMLSelectElement>('local-hub'),
  localType: id<HTMLSelectElement>('local-type'),
  localOrigin: id<HTMLSelectElement>('local-origin'),
  localAssetCount: id<HTMLInputElement>('local-asset-count'),
  localDate: id<HTMLInputElement>('local-date'),
  localQuarter: id<HTMLSelectElement>('local-quarter'),
  localProject: id<HTMLInputElement>('local-project'),
  localProduct: id<HTMLInputElement>('local-product'),
  createLocalProjectBtn: id('create-local-project-btn'),
  localMessage: id('local-message'),

  adminAssetCount: id('admin-asset-count'),
  adminForecastCount: id('admin-forecast-count'),
  syncValidatedBtn: id('sync-validated-btn'),
  rulesTableBody: id('rules-table-body'),
  addRuleBtn: id('add-rule-btn'),
  ruleFormCard: id('rule-form-card'),
  ruleFormTitle: id('rule-form-title'),
  ruleHub: id<HTMLSelectElement>('rule-hub'),
  ruleDivision: id<HTMLSelectElement>('rule-division'),
  ruleAssetParent: id<HTMLInputElement>('rule-asset-parent'),
  ruleAssetChild: id<HTMLInputElement>('rule-asset-child'),
  ruleLanguages: id<HTMLInputElement>('rule-languages'),
  ruleLanguageList: id('rule-language-list'),
  ruleTranslationPct: id<HTMLInputElement>('rule-translation-pct'),
  saveRuleBtn: id('save-rule-btn'),
  cancelRuleBtn: id('cancel-rule-btn'),

  creatorCard: id('creator-card'),
  creatorDivision: id<HTMLSelectElement>('creator-division'),
  creatorBrand: id<HTMLSelectElement>('creator-brand'),
  creatorHub: id<HTMLSelectElement>('creator-hub'),
  creatorType: id<HTMLSelectElement>('creator-type'),
  creatorInitiativeOrigin: id<HTMLSelectElement>('creator-initiative-origin'),
  creatorSkyCount: id<HTMLInputElement>('creator-sky-count'),
  creatorSkyCountValue: id('creator-sky-count-value'),
  creatorProject: id<HTMLInputElement>('creator-project'),
  creatorProduct: id<HTMLInputElement>('creator-product'),
  creatorEans: id<HTMLTextAreaElement>('creator-eans'),
  creatorVariations: id<HTMLInputElement>('creator-variations'),
  creatorQuarter: id<HTMLSelectElement>('creator-quarter'),
  creatorDate: id<HTMLInputElement>('creator-date'),
  createMasterBtn: id('create-master-btn'),
  creatorMessage: id('creator-message'),

  matrixFilterDivision: id<HTMLSelectElement>('matrix-filter-division'),
  matrixFilterBrand: id<HTMLSelectElement>('matrix-filter-brand'),
  matrixFilterHub: id<HTMLSelectElement>('matrix-filter-hub'),
  matrixFilterQuarter: id<HTMLSelectElement>('matrix-filter-quarter'),
  matrixFilterStatus: id<HTMLSelectElement>('matrix-filter-status'),
  matrixTableBody: id('matrix-table-body'),

  bookingFilterDivision: id<HTMLSelectElement>('booking-filter-division'),
  bookingFilterBrand: id<HTMLSelectElement>('booking-filter-brand'),
  bookingFilterHub: id<HTMLSelectElement>('booking-filter-hub'),
  configCard: id('config-card'),
  configTypes: id('config-types'),
  configDivisions: id('config-divisions'),
  configBrands: id('config-brands'),
  configHubs: id('config-hubs'),
  configQuarters: id('config-quarters'),

  creatorFormTab: id('creator-form-tab'),
  creatorCsvTab: id('creator-csv-tab'),
  creatorBulkTab: id('creator-bulk-tab'),
  tabBtns: qAll('.tab-btn'),

  csvFileInput: id<HTMLInputElement>('csv-file-input'),
  csvUploadBtn: id('csv-upload-btn'),
  csvMessage: id('csv-message'),

  bulkSkus: id<HTMLTextAreaElement>('bulk-skus'),
  bulkProject: id<HTMLInputElement>('bulk-project'),
  bulkFormRows: id('bulk-form-rows'),
  bulkCreateBtn: id('bulk-create-btn'),
  bulkMessage: id('bulk-message'),
  dataLoading: id('data-loading'),
  loginModal: id('login-modal'),
  loginBtn: id('login-btn'),
  authError: id('auth-error'),
  authLoading: id('auth-loading'),
};
